import React, { Component } from 'react';
import _ from 'lodash';
import {
	Container,
	Modal,
	Typography,
	Box,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Stack,
	Tooltip,
	Alert,
	FormGroup,
	Input,
	ButtonGroup,
	InputLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DoneIcon from '@mui/icons-material/Done';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { connect } from 'react-redux';
import { post } from '../util/api';
//import AccountProgress from '../components/AccountProgress';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
};

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

class Agent extends Component {
	state = {
		loading: true,
		showAdd: false,
		showUpdate: false,
		mail: '',
		userMail: this.props.access.user.loggedUserObj.email,
		submittedEmail: '',
		deleteBtnClicked: false,
		delSelected: '',
		MessageVis: true,
		goToSubs: false,
		open: false,
	};
	componentDidMount() {
		this.getList();
	}

	refresh() {
		this.setState({ loading: true });
		this.getList();
	}
	handleClick = (value, email, uid, extra) => () => {
		if (value === 'add') {
			if (this.props.product.settings.agent_limit <= this.state.list.length + 1) {
				this.setState({ goToSubs: true, open: true });
			} else {
				this.setState({ showAdd: true, showUpdate: false, mail: '', name: '', surname: '', password: '', open: false });
			}
		}
		if (value === 'update') {
			this.setState({
				showUpdate: true,
				showAdd: false,
				mail: email,
				name: extra.name,
				surname: extra.surname,
				password: extra.password,
				selectedUid: uid,
				open: false,
			});
		}
	};
	handleClickCancel = () => {
		this.setState({ showAdd: false, showUpdate: false, mail: '', name: '', surname: '', password: '' });
	};
	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

	handleSubmit = () => {
		this.addAgent();
		this.setState({ showAdd: false, mail: '', name: '', surname: '', password: '' });
	};
	handleSubmitUpdate = () => {
		this.updateAgent();
		this.setState({ showUpdate: false, mail: '', name: '', surname: '', password: '' });
	};
	handleClickDelete = () => {
		this.deleteAgent();
	};
	openDeleteButton = (value) => () => {
		this.setState({ delSelected: value.email, selectedUid: value.uid, deleteBtnClicked: true });
	};
	closeDeleteButton = () => {
		this.setState({ deleteBtnClicked: false, goToSubs: false, open: false });
	};

	handleOpen = () => {
		this.setState({ deleteBtnClicked: true, goToSubs: true, open: true });
	};
	handleClose = () => {
		this.setState({ deleteBtnClicked: false, goToSubs: false, open: false });
	};

	async getList() {
		let list = await post('/maytapi/agent/list', {
			pid: this.props.product.id,
		});
		this.setState({ loading: false, list: list.data.agents });
	}

	async addAgent() {
		this.state.mail === this.state.userMail
			? this.setState({ Message: 'This agent has been added.', MessagePos: false, MessageNeg: true, MessageVis: false })
			: await post('/maytapi/agent/add', {
					pid: this.props.product.id,
					email: this.state.mail,
					password: this.state.password,
					update_data: {
						name: this.state.name,
						surname: this.state.surname,
					},
			  }).then((data) => {
					if (data.data.success) {
						this.setState({ Message: 'Agent successfully added.', MessagePos: true, MessageNeg: false, MessageVis: false });
						this.refresh();
					} else {
						this.setState({ Message: 'This agent has been added.', MessagePos: false, MessageNeg: true, MessageVis: false });
					}
			  });
	}
	async updateAgent() {
		await post('/maytapi/agent/update', {
			pid: this.props.product.id,
			uid: this.state.selectedUid,
			email: this.state.delSelected,
			update_data: {
				name: this.state.name,
				surname: this.state.surname,
				password: this.state.password,
			},
		}).then((data) => {
			if (data.data.success) {
				this.setState({ MessageVis: false, Message: 'Agent successfully updeted.', MessagePos: true, MessageNeg: false });
				this.refresh();
			} else {
				this.setState({ Message: 'Error', MessagePos: false, MessageNeg: true, MessageVis: false });
			}
		});
	}
	async deleteAgent() {
		await post('/maytapi/agent/delete', {
			pid: this.props.product.id,
			uid: this.state.selectedUid,
			email: this.state.delSelected,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ MessageVis: false, Message: 'Agent successfully deleted.', MessagePos: true, MessageNeg: false });
				this.refresh();
			} else {
				this.setState({ Message: 'Error', MessagePos: false, MessageNeg: true, MessageVis: false });
			}
		});
		this.setState({ deleteBtnClicked: false });
	}
	render() {
		let list = _.concat([this.props.access.user.loggedUserObj], this.state.list);
		let trial = this.props.product.trial;
		list = _.orderBy(list, ['id'], ['asc']);
		let admin = this.props.access.user.loggedUserObj;
		let adminMail = admin.email;
		const { mail, name, password, surname } = this.state;
		if (this.state.loading) {
			return (
				<Page title="Agents" icon={<PeopleOutlineIcon />}>
					<Page.Loader></Page.Loader>
				</Page>
			);
		}
		if (!this.props.product.settings || !this.props.product.settings.agent_limit) {
			return (
				<Page title="Agents" icon={<PeopleOutlineIcon />}>
					<Page.Wrap>
						<Container>
							<div style={{ textAlign: 'center' }}>
								<div>
									<PeopleAltIcon />
								</div>
								<h2>No Agent Limit</h2>
								<p>Buy agents subscription.</p>
								<Button href={Link} to="/subscription" variant="outlined">
									{trial === null ? 'Start Free Trial' : 'Go to Subscription'}
								</Button>
								{/* <div>
										<Icon size="big" name="setting"></Icon>
									</div>
									<h2>Upgrading</h2>
									<p>Maytapi is upgrading.</p> */}
							</div>
						</Container>
					</Page.Wrap>
				</Page>
			);
		}
		return (
			<Page title="Agents" icon={<PeopleOutlineIcon />}>
				<Page.Wrap>
					<Container sx={{ padding: '0 !important' }}>
						{list.length > this.props.product.settings.agent_limit ? (
							<Alert severity="error" sx={{ marginBottom: '10px' }}>
								For all agents can use chat, you must increase agent limit.
								<a as={Link} href="/subscription">
									{' '}
									Go to subscription page.
								</a>
							</Alert>
						) : null}
						<TableContainer component={Paper} sx={{ padding: '0' }}>
							<Table sx={{ background: '#fafafa' }}>
								<TableHead>
									<TableRow>
										<TableCell>Email</TableCell>
										<TableCell>Name</TableCell>
										<TableCell></TableCell>
										<TableCell align="right">
											{!this.state.show ? (
												<Button variant="outlined" onClick={this.handleClick('add', '')}>
													Add Agent ( {list.length} / {this.props.product.settings.agent_limit} )
												</Button>
											) : (
												''
											)}
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{list ? (
										_.map(list, (data, index) => (
											<TableRow key={index}>
												<TableCell>{data.email}</TableCell>
												<TableCell>
													{data.name ? data.name + ' ' + (data.surname === null ? '' : data.surname) : 'Update and Enter Name'}
												</TableCell>
												<TableCell>
													{index + 1 > this.props.product.settings.agent_limit ? (
														<div>
															<Tooltip title="This agent can't use chat. Please subscribe to agent subscription." placement="top">
																<Button
																	aria-owns={this.state.popup ? 'mouse-over-popover' : undefined}
																	aria-haspopup="true"
																	style={{ color: 'red' }}
																	onMouseEnter={() => {
																		this.setState({ popup: true });
																	}}
																	onMouseLeave={() => {
																		this.setState({ popup: false });
																	}}
																>
																	Subscription
																</Button>
															</Tooltip>
														</div>
													) : null}
												</TableCell>
												{data.email !== adminMail && (
													<TableCell style={{ textAlign: 'right' }}>
														<Button
															sx={{ margin: '5px' }}
															variant="outlined"
															onClick={this.handleClick('update', data.email, data.uid, data)}
														>
															<i
																className="edit icon"
																style={{
																	color: 'black',
																	opacity: 1,
																	margin: 0,
																	textAlign: 'center',
																	width: '20px',
																	height: '20px',
																}}
															></i>
														</Button>
														<Button
															variant="outlined"
															sx={{ margin: '5px' }}
															onClick={this.openDeleteButton({ email: data.email, uid: data.uid })}
														>
															<i
																className="trash icon"
																style={{
																	color: 'black',
																	opacity: 1,
																	margin: 0,
																	textAlign: 'center',
																	width: '20px',
																	height: '20px',
																}}
															></i>
														</Button>
													</TableCell>
												)}
											</TableRow>
										))
									) : (
										<TableRow key="nodata">
											<TableCell>There is no agent.</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>

						{this.state.showAdd ? (
							<form onSubmit={this.handleSubmit} style={{ margin: '15px 0 15px' }}>
								<FormGroup>
									<InputLabel shrink htmlFor="bootstrap-input">
										Mail
									</InputLabel>
									<Input width="8" placeholder="Email" name="mail" value={mail} sx={{ marginBottom: '10px' }} onChange={this.handleChange} fluid required type="email" />
									<InputLabel shrink htmlFor="bootstrap-input">
										Password
									</InputLabel>
									<Input
										width="6"
										placeholder="Password"
										name="password"
										value={password}
										onChange={this.handleChange}
										fluid
										required
										minLength="6"
									/>
									<ButtonGroup sx={{ textAlign: 'center', display: 'flow-root', marginTop: '15px' }}>
										<Button positive type="Submit">
											Submit
										</Button>
										<Button negative onClick={this.handleClickCancel} content="Cancel">
											Cancel
										</Button>
									</ButtonGroup>
								</FormGroup>
							</form>
						) : (
							''
						)}
						{this.state.showUpdate ? (
							<form onSubmit={this.handleSubmitUpdate} style={{ margin: '15px 0 15px' }}>
								<FormGroup>
									<InputLabel shrink htmlFor="bootstrap-input">
										Mail
									</InputLabel>
									<Input
										placeholder="Email"
										label="mail"
										name="mail"
										type="mail"
										value={mail}
										onChange={this.handleChange}
										fluid
										required
										readOnly
										sx={{ marginBottom: '10px' }}
									/>
									<InputLabel shrink htmlFor="bootstrap-input">
										Name
									</InputLabel>
									<Input
										placeholder="Name"
										label="name"
										name="name"
										sx={{ marginBottom: '10px' }}
										value={name}
										onChange={this.handleChange}
										fluid
										required
									/>
									<InputLabel shrink htmlFor="bootstrap-input">
										Surname
									</InputLabel>
									<Input placeholder="Surname" label="surname" sx={{ marginBottom: '10px' }} name="surname" value={surname} onChange={this.handleChange} fluid required />
									<InputLabel shrink htmlFor="bootstrap-input">
										Password
									</InputLabel>
									<Input placeholder="Password" label="password" sx={{ marginBottom: '10px' }} name="password" value={password} onChange={this.handleChange} />
									<ButtonGroup sx={{ textAlign: 'center', display: 'flow-root', marginTop: '15px' }}>
										<Button positive type="Submit">
											Submit
										</Button>
										<Button negative onClick={this.handleClickCancel} type="Cancel">
											Cancel
										</Button>
									</ButtonGroup>
								</FormGroup>
							</form>
						) : (
							''
						)}
						{/* <Message hidden={this.state.MessageVis} positive={this.state.MessagePos} negative={this.state.MessageNeg}>
							{this.state.Message}
						</Message> */}
						{this.state.MessageVis ? (
							<>
								{this.state.MessagePos ? <Alert severity="success">{this.state.Message}</Alert> : null}
								{this.state.MessageNeg ? <Alert severity="success">{this.state.Message}</Alert> : null}
							</>
						) : null}

						<Stack spacing={2} sx={{ marginTop: '15px' }}>
							<Item style={{ fontSize: '18px' }}>
								Agents can login on
								<a target="_blank" href="https://chat.maytapi.com" rel="noopener noreferrer">
									{' '}
									chat.maytapi.com
								</a>
							</Item>
						</Stack>
						{/*delete modal*/}
						<Modal
							sx={{ background: '#000000ad' }}
							hideBackdrop
							open={this.state.deleteBtnClicked}
							onClose={this.handleClose}
							aria-labelledby="child-modal-title"
							aria-describedby="child-modal-description"
						>
							<Box sx={style}>
								<Typography id="modal-modal-title" variant="h6" component="h2">
									Are you sure you want to delete the agent?
								</Typography>
								<Typography id="modal-modal-description" sx={{ mt: 2 }}>
									<ButtonGroup>
										<Button variant="outlined" onClick={this.closeDeleteButton} startIcon={<CancelIcon />}>
											No
										</Button>
										<Button variant="outlined" onClick={this.handleClickDelete} startIcon={<DoneIcon />}>
											Yes
										</Button>
									</ButtonGroup>
								</Typography>
							</Box>
						</Modal>
						{/*go to subs modal*/}
						<Modal
							sx={{ background: '#000000ad' }}
							hideBackdrop
							open={this.state.open}
							onClose={this.handleClose}
							aria-labelledby="child-modal-title"
							aria-describedby="child-modal-description"
						>
							<Box sx={style}>
								<Typography id="modal-modal-title" variant="h6" component="h5">
									Your agents limit is not enough for add new agent.
								</Typography>
								<Typography id="modal-modal-title" variant="subtitle1" gutterBottom component="div">
									Do you want to update agent subscription.
								</Typography>
								<Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
									<Button variant="outlined" onClick={this.closeDeleteButton} sx={{ marginRight: '10px' }} startIcon={<CancelIcon />}>
										No
									</Button>
									<Button variant="outlined" href="/subscription" startIcon={<DoneIcon />}>
										Yes
									</Button>
								</Typography>
							</Box>
						</Modal>
					</Container>
				</Page.Wrap>
			</Page>
		);
	}
}
const stateToProps = (state) => ({ access: state.access, product: state.product.maytapi, location: state.router.location });
export default connect(stateToProps)(Agent);
